import type * as models from '../../models'
import type { Plugin } from '../plugin'

import type { Manager } from './manager'

export class Selectors<TTypeParams extends models.TypeParams.Constraint> {
  /**
   * TODO:
   */
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly allPluginsHaveBeenInstantiated

  /**
   * TODO:
   */
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly allPluginsAreReady

  /**
   * @deprecated we no longer ready one plugin at a time. Use {@link allPluginsAreReady}
   */
  // NOTE: intentionally not typed here so that type can be inferred
  public readonly isPluginReady

  constructor(manager: Manager<TTypeParams>) {
    const pluginsStatus = manager.feature.state.project(
      state => state.pluginsStatus,
    )

    this.allPluginsAreReady = pluginsStatus.project(
      status => status === 'initialized',
    )
    this.allPluginsHaveBeenInstantiated = pluginsStatus.project(
      this.allPluginsAreReady.asSelector,
      (status, allPluginsAreReady) =>
        allPluginsAreReady || status === 'instantiated',
    )

    this.isPluginReady = manager.feature.createSelectorMethod(
      (pluginId: Plugin.Id) => this.allPluginsAreReady.asSelector,
    )
  }
}
